import {StyleSheet, Platform} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    centeredView: {
      flex: 1,
      justifyContent: 'center',
      alignItems: Platform.OS === 'web' ? 'center' : undefined,
      backgroundColor: colors.overlay,
    },
    modalView: {
      margin: 24,
      backgroundColor: colors.surfaceElevated,
      borderRadius: 20,
      // Shadows stay literal black on both themes (decorative-exempt —
      // docs/DARK-MODE.md).
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
      width: Platform.OS === 'web' ? 300 : undefined,
    },
    buttonsContainer: {
      flexDirection: 'row',
      paddingHorizontal: 16,
      marginBottom: 24,
    },
    marginBottom24: {
      marginBottom: 24,
    },
    leftButton: {
      flex: 1,
    },
    rightButton: {
      flex: 1,
      marginLeft: 16,
    },
    headerContainer: {
      padding: 24,
      backgroundColor: colors.backgroundMuted,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
    },
    marginRight10: {
      marginRight: 10,
    },
    margin16: {
      margin: 16,
    },
    titleContainer: {
      marginTop: 8,
      flexDirection: 'row',
      alignItems: 'center',
    },
    webContainer: {
      backgroundColor: colors.overlayLight,
      ...CommonStyles.flex_center,
    },
    detailsContainer: {
      minWidth: 375,
      ...CommonStyles.br_16,
    },
    calendarIcon: {
      width: 15,
      height: 15,
    },
  });

export default makeStyles;
